export default __webpack_public_path__ + "static/media/eat.53b1fa8d.mp3";